import { render, staticRenderFns } from "./PendingEventsTab.vue?vue&type=template&id=3a0a1396&scoped=true&"
import script from "./PendingEventsTab.vue?vue&type=script&lang=js&"
export * from "./PendingEventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a1396",
  null
  
)

export default component.exports